import React, { Component } from 'react'

export default class WorksDueVolteLalba extends Component {
    render() {
        return (
            <div class="modal" id="worksduevoltelalba" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>&quot;Due volte l'alba&quot; </strong>(romanzo): <em>Marsilio Editori, Venezia, 2002.</em><br /> <br /></h5>
                           
                        </div>
                        <div class="modal-body p-4" id="result">



                            <div align="left">




                                <br />
                                Milo è un docente di Economia, è separato da anni, ha una figlia adolescente che vive insieme alla m<br /><br/>
                                    e solo ogni tanto trascorre dei brevi periodi con lui. <br />
                                    All'inizio di questa storia lo vediamo partire per una vacanza al mare insieme a Silvia,<br />
                                    la compagna con cui ha una relazione da qualche mese, e al figlio sedicenne di lei. <br />
                                    Il caso o il destino fanno sì che proprio lungo il tragitto che lo porta verso il luogo della vacanz<br />r>
  la riviera Adriatica dove ha vissuto gli anni della propria giovinezza, Milo si ritrovi davanti<br />
                                    l'immagine di Iana, il primo e ineguagliato amore della sua vita. <br />
                                    Una donna dotata di una personalità forte e nel contempo fragilissima, generosa e inquieta<br />r>
  Da quel momento la figura di Iana comincia ad agire come una trivella, che gli fa franare sotto i piedi <br />
                                    il terreno della propria sorvegliata esistenza.<br />
                                    Milo vive con Silvia e suo figlio i primi giorni di mare, viene raggiunto per qualche giorno anche alla figlia,<br />
                                    ma i suoi pensieri sono sempre più assorbiti da Iana, finchè decide di partire alla sua ricerca.<br /><br/>
                                        L'indagine si trasforma in un inseguimento, in un viaggio al termine del quale Milo scoprirà in sè una nuova volontà e capacità di vivere il presente.
<br /><br />



                                        <strong>Incipit</strong> <br /><br />

                                        l'ho ucciso. Sono stato io. Solo dirlo mi fa inorridire ed è accaduto. Un ragazzo di ventidue anni. Non l'ho visto, impossibile vederlo. Mi è schizzato davanti come uno straccio alzato dal vento. Lo vedo come in sogno. Vorrei che fosse un sogno ma so che è tutto vero. E' successo da quattro ore e pare un momento fa, poi invece mi sembra passata un'eternità da quando sono precipitato in questo abisso. <br/>
                                            E' buio pesto e piove a dirotto, i tergicristallo a doppia velocità non bastano a tenere sgombro il parabrezza. Ho sollevato una colonna d'acqua con le ruote di destra poco prima. Neanche il tempo di piantare il piede sul pedale del freno. Non potevo fare niente per evitarlo. Continuo a ripetermelo fino a spolpare le parole ma non serve. Le parole dicono una verità futile, che non riesce nemmeno a sfiorare ciò che è accaduto. <br/>
                                                l'impatto è stato tremendo. Una volta ho investito un cane, un grosso cane e anche lìera di notte. Ci si accorge che si tratta di qualcosa di vivo, di carne e ossa. Si sente la vita che si spezza. Ma stavolta era un uomo, un ragazzo. l'ho preso in pieno, spazzato via come un birillo. Travolto col peso di un macigno. Ha lasciato una scarpa in mezzo alla carreggiata, un mocassino sformato che si è riempito di pioggia, ho visto le gocce che ci schizzavano dentro.<br/>
                                                    Mi è sembrato di colpirlo col mio stesso corpo, da come l'urto mi si è scaricato nelle membra. Le braccia irrigidite sul volante hanno cominciato a tremare e da quel momento non hanno più smesso. Ho sentito il colpo della testa contro il cofano, prima che il corpo fosse scagliato via.<br/>
                                                        Vedere no, non ho visto quasi niente. Un'ombra che piroetta davanti al vetro. Ha attraversato come un gatto, si è lanciato avanti senza guardare. è saltato giù dal guardrail. Come ha potuto non vedere i fari? Ha calcolato male i tempi. è rimasto abbagliato. Diluvia e il corpo a terra è fradicio, zuppo come una spugna. Non si vede nemmeno una goccia di sangue e l'acqua gli stilla dai capelli. <br/>
                                                            Sono bagnato fradicio anch'io. La pioggia mi scorre a rivoli sulle guance e già per la schiena. Lo guardo da vicino, alla luce delle torce dei poliziotti. Il corpo è sdraiato sul limite della carreggiata, a faccia in già, col viso piegato e un braccio allungato sopra la testa, come se stesse nuotando. Senza scarpe i piedi sembrano piccoli, nei calzini di cotone con la riga rossa. <br/>
                                                                Dal suo profilo, più che dal colore della pelle, capisco subito che è straniero. Ha gli occhi appena socchiusi e per un momento voglio ancora sperare che sia vivo, ma il poliziotto che si è chinato su di lui si rialza e mi dice che è morto. <br/>
                                                                    è 'morto sul colpo' ha precisato. Come faceva a esserne così sicuro? Quando gli infermieri hanno rimosso il corpo ho visto che era spezzato in due, non si tenevano più insieme le gambe col tronco. Sulla mia auto solo una modesta ammaccatura, e un faro incrinato. Le automobili sono armi improprie che andrebbero proibite. La patente non puù essere una licenza di uccidere, seppure in osservanza della legge, nel rispetto del codice stradale. <br/>
                                                                        Andavo sotto i settanta, che è il limite di velocità di quel tratto. Non è stata colpa mia. Quel tipo non si stancava di ripetermelo, col suo bravo giubbetto a strisce arancioni che io neanche avevo considerato di indossare. Continuava a dirlo al poliziotto che stendeva il verbale, e a me assicurava che sarebbe anche stato disposto a testimoniarlo. Mi prefigurava l'aula del tribunale col giudice togato e altri quadri temibili, ma che erano niente in confronto al corpo battuto dalla pioggia. <br/>
                                                                            l'ho ucciso ma non è stata colpa mia: il non senso è evidente. Un ragazzo di ventidue anni, meno di metà di quelli che ho io, più giovane dei miei figli. Un crimine contro natura. Ho ucciso un uomo e questo mi colma di orrore e mi rivolgo a Dio e gli domando: come hai potuto generare una creatura capace di un abominio simile!?
                                                                            
                                                                            
                                        <br />

                                                                            <strong>ne hanno scritto:</strong> <br /><br />

                                                                            Fulvio Panzeri, Avvenire  30/04/2002<br />
                                                                            Roberto Carnero, Famiglia Cristiana 28/04/2002<br />
                                                                            Giuseppe Amoroso, Gazzetta del Sud 12/04/2002<br />
                                                                            Massimo Onofri, Il Diario della settimana 23/08/2002<br />
                                                                            Luigi Serravalli, Alto Adige 03/04/2002<br />
                                                                            Guido Conti, Italia Oggi 25/05/2002<br />
                                                                            Daniele Piccini, Il Giornale 15/05/2002<br />
                                                                            Lisa Oppici, Gazzetta di Parma 04/07/2002<br />
                                                                            Francesco Roat, L'Indice dei libri del mese Luglio-Agosto 2002<br />
                                                                            Alessandro Genovese, L'Adige 26/03/2002<br />
                                                                            Silvia Ceschini, Vita Trentina 24/03/2002
Carlo Martinelli, Trentino Magazine 31/05/2002<br />
                                                                            Giuseppe Petralia, Il Belice Agosto 2002<br />
                                                                            Il Piccolo di Trieste 07/07/2002<br />
                                                                            L'Espresso 18/07/2002
                                                                            
                                                                            
                                                                            
</div>












            </div>





            <div align="left">
<strong>Selezione Stampa</strong>

<table border="0" align="center" cellspacing="7"  >
     <tr>
        
        <td align="center" width="100%">&quot;Incoscienti speranze&quot; di
       Massimo Onofri. (166k)</td><td><a href="rec\alba-incoscientisperanze.zip"><img
        src="./img/rec/alba-incoscientisperanze_small.jpg" alt="scarica in formato zip" width="160" height="200"></img></a>

        </td>
 </tr>

     <tr>
        
        <td align="center" width="100%">&quot;L'eterno rimpianto di un amore perduto&quot; di
       Robero Carnero. (102k)</td><td><a href="rec\alba-leternorimpianto.zip"><img
        src="./img/rec/alba-leternorimpianto_small.jpg" alt="scarica in formato zip" width="160" height="160"></img></a>

        </td>
 </tr>

   <tr>
        
        <td align="center" width="100%">&quot;Chiamato a fare i conti con l'infido universo&quot; di
       Giuseppe Amoroso. (102k)</td><td><a href="rec\alba-conticonluniverso.zip"><img
        src="./img/rec/alba-conticonluniverso_small.jpg" alt="scarica in formato zip" width="160" height="349"></img></a>

        </td>
 </tr>



 



 
</table>
</div>









                                                                    <div class="modal-footer">
                                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                                                                    </div>
                            </div>
                        </div>
                    </div>


                                                        )
                                                      }
                                                    }
